import React, {useEffect, useState} from 'react';
import "../utils/Style/component/auto-conversion.scss";

function AutoConversionToggle({isChecked, handle_toggleChange, convertText, disabled}) {
    const [checkedText, setCheckedText] = useState("Off");
    const [toggleClass, setToggleClass] = useState("toggle-input");

    useEffect(() => {
        setCheckedText(isChecked ? "On" : "Off");
        setToggleClass(isChecked ? "toggle-input checked-toggle" : "toggle-input");
    }, [isChecked]);

    return (
        <div>
            <div className="auto-conversion">
                <div className={disabled? "card disabled": "card"}>
                    <div className="row">
                        <div className="label col-9">
                            <div className="title">Auto-Conversion</div>
                            <div className="desc">{convertText}</div>
                        </div>
                        <div className="toggle row col-3">
                            <div className="toggle-switch col-8">
                                <div
                                    id="toggle"
                                    className={toggleClass}
                                    onClick={() => {
                                        handle_toggleChange();
                                    }}
                                />
                                <label htmlFor="toggle" className="toggle-label"/>
                            </div>
                            <div className="label col-4">{checkedText}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AutoConversionToggle;